import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import { selector as parseSelector } from 'vega-event-selector';
import { isString } from 'vega-util';
import { TUPLE } from '..';
import { varName } from '../../../util';
import inputBindings from './inputs';
import toggle, { TOGGLE } from './toggle';
var clear = {
  has: function has(selCmpt) {
    return selCmpt.clear !== undefined && selCmpt.clear !== false;
  },
  parse: function parse(model, selCmpt, selDef) {
    if (selDef.clear) {
      selCmpt.clear = isString(selDef.clear) ? parseSelector(selDef.clear, 'scope') : selDef.clear;
    }
  },
  topLevelSignals: function topLevelSignals(model, selCmpt, signals) {
    if (inputBindings.has(selCmpt)) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var proj = _step.value;
          var idx = signals.findIndex(function (n) {
            return n.name === varName("".concat(selCmpt.name, "_").concat(proj.field));
          });

          if (idx !== -1) {
            signals[idx].on.push({
              events: selCmpt.clear,
              update: 'null'
            });
          }
        };

        for (var _iterator = selCmpt.project.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }

    return signals;
  },
  signals: function signals(model, selCmpt, _signals) {
    function addClear(idx, update) {
      if (idx !== -1 && _signals[idx].on) {
        _signals[idx].on.push({
          events: selCmpt.clear,
          update: update
        });
      }
    } // Be as minimalist as possible when adding clear triggers to minimize dataflow execution.


    if (selCmpt.type === 'interval') {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        var _loop2 = function _loop2() {
          var proj = _step2.value;

          var vIdx = _signals.findIndex(function (n) {
            return n.name === proj.signals.visual;
          });

          addClear(vIdx, '[0, 0]');

          if (vIdx === -1) {
            var dIdx = _signals.findIndex(function (n) {
              return n.name === proj.signals.data;
            });

            addClear(dIdx, 'null');
          }
        };

        for (var _iterator2 = selCmpt.project.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          _loop2();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    } else {
      var tIdx = _signals.findIndex(function (n) {
        return n.name === selCmpt.name + TUPLE;
      });

      addClear(tIdx, 'null');

      if (toggle.has(selCmpt)) {
        tIdx = _signals.findIndex(function (n) {
          return n.name === selCmpt.name + TOGGLE;
        });
        addClear(tIdx, 'false');
      }
    }

    return _signals;
  }
};
export default clear;